type FullStoryModule = typeof import('@fullstory/browser');

type RuntimeEnvironment = {
  ENABLE_FULLSTORY?: boolean | string;
  REACT_APP_FULLSTORY_ORG_ID?: string;
};

const getRuntimeEnvironment = (): RuntimeEnvironment => {
  return ((window as any).__environment__ ?? {}) as RuntimeEnvironment;
};

const isFullStoryEnabled = (): boolean => {
  const { ENABLE_FULLSTORY } = getRuntimeEnvironment();

  if (typeof ENABLE_FULLSTORY === 'boolean') {
    return ENABLE_FULLSTORY;
  }

  if (typeof ENABLE_FULLSTORY === 'string') {
    return ENABLE_FULLSTORY.trim().toLowerCase() === 'true';
  }

  return false;
};

let fullStoryModulePromise: Promise<FullStoryModule | null> | null = null;

const loadFullStory = async (): Promise<FullStoryModule | null> => {
  const { REACT_APP_FULLSTORY_ORG_ID: orgId } = getRuntimeEnvironment();

  if (!isFullStoryEnabled() || !orgId?.trim()) {
    return null;
  }

  if (!fullStoryModulePromise) {
    fullStoryModulePromise = import('@fullstory/browser');
  }

  return fullStoryModulePromise;
};

export const initializeFullStory = async (): Promise<void> => {
  const fullStory = await loadFullStory();

  if (!fullStory) {
    return;
  }

  fullStory.init({
    orgId: getRuntimeEnvironment().REACT_APP_FULLSTORY_ORG_ID!,
  });
};

export const setFullStoryUserProperties = async (
  emailAddress?: string,
): Promise<void> => {
  if (!emailAddress) {
    return;
  }

  const fullStory = await loadFullStory();

  if (!fullStory) {
    return;
  }

  fullStory.FullStory('setProperties', {
    type: 'user',
    properties: {
      email: emailAddress,
    },
  });
};

export { isFullStoryEnabled };
